async function loadCustomFont(font) {
  if (!document.fonts.check(`42px ${font.name}`)) {
    const newFont = new FontFace(font.name, `url(${font.url})`);
    await newFont.load();
    document.fonts.add(newFont);
  }
  return font.name;
}
export const loadCustomFonts = async (fonts, log) => {
  for (const font of fonts) {
    try {
      await loadCustomFont(font);
    } catch (error) {
      log.error(['SpotlightState', 'SpotlightPlayer'], `Error loading fonts. Fonts: ${JSON.stringify(font)}, error: ${error}`);
    }
  }
};